<template>
  <div>
    <Head title="Home" />
    
    <div v-if="owner === false">

      <PageHeader
        title="Welcome to ESTAT Hub"
        icon="dashboard"
        description="The ECoS Energy Statistics (ESTAT) Hub is a centralized platform developed by the Energy Commission of Sabah (ECoS) to collect, manage, and present comprehensive energy statistics across Sabah. The system provides valuable insights into electricity generation, energy sources, installed capacity, and other key energy indicators, supporting effective monitoring, analysis, and strategic planning. ESTAT promotes data transparency, accuracy, and accessibility, enabling informed decision-making and supporting the sustainable development of Sabah's energy sector."
      />
      <img src="/images/background.jpg"
          alt="Energy statistics and renewable energy"
          class="block w-full h-auto" />

    </div>
    
    <div v-if="owner==true">

    <PageHeader title="Dashboard" icon="dashboard" />

    

    <div class="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-5">

      <VCardElement
        name="canvas_3b"
        color="#eaeaea"
        label="Jumlah Aduan"
        :title="String(issues)"
        content=""
        text_color="#1c14a3"
        elevation="1"
        icon_box="white"
        icon_color="teal"
        icon="note_alt"
      />

      <VCardElement
        name="canvas_3b"
        color="#eaeaea"
        label="Aduan Dihantar"
        :title="String(submitted)"
        content=""
        text_color="#1c14a3"
        elevation="1"
        icon_box="white"
        icon_color="teal"
        icon="content_paste_go"
      />

      <VCardElement
        name="canvas_3b"
        color="#eaeaea"
        label="Aduan dalam draf"
        :title="String(drafts)"
        content=""
        text_color="#1c14a3"
        elevation="1"
        icon_box="white"
        icon_color="teal"
        icon="description"
      />

      <VCardElement
        name="canvas_3b"
        color="#eaeaea"
        label="Aduan dalam siasatan/tindakan"
        :title="String(investigation)"
        content=""
        text_color="#1c14a3"
        elevation="1"
        icon_box="white"
        icon_color="teal"
        icon="content_paste_search"
      />

      <VCardElement
        name="canvas_3b"
        color="#eaeaea"
        label="Aduan Ditutup/Diselesaikan"
        :title="String(completed)"
        content=""
        text_color="#1c14a3"
        elevation="1"
        icon_box="white"
        icon_color="teal"
        icon="fact_check"
      />

    </div> 

    </div>     
    
    <Modal @close="toggleDisclaimer" :modalActive="modalDisclaimer" @submit="closeDisclaimer" :hideClose="true" :hideSubmit="true" submitLabel="Tutup" closeLabel="Kembali">
      <div class="mx-4">
        <div class="flex justify-end py-3 mb-6">
          <button 
            class="btn-indigo cursor-pointer flex items-center px-4 py-2 focus:text-indigo-500"
            @click="closeDisclaimer"
          >
            Tutup
          </button>
        </div>         
        <span class="block text-center text-base text-gray-700 mb-3 text-small">
          <p>Saluran Aduan (iLAPOR) ini hanya untuk melaporkan aduan berkaitan pelanggaran integriti dan salah laku bagi Warga ECoS sahaja.</p>
          <p class="pt-2">Sebarang aduan berkaitan perkhidmatan atau lain-lain, pihak tuan/puan boleh membuat aduan secara terus melalui 
            <a target="_blank" href="https://talk2.ecos.services/" class="font-bold">talk2ecos</a>.
          </p>
        </span>
        
        <div class="text-center">
          <img class="block mx-auto" src="/images/pemakluman.jpg" />
        </div>
        
        <span class="block text-center text-base text-gray-700 mb-3 text-small">
          <p>Maklumat peribadi dan aduan integriti yang dilaporkan akan dilindungi dan dirahsiakan di bawah Akta Perlindungan Pemberi Maklumat 2010 (Akta 711) / Whistleblowers Protection Act 2010 (Act 711) Sila Pastikan Maklumat Aduan yang diisi adalah tepat dan jelas.</p>
        </span>
      </div>
    </Modal>    
    
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import { ref } from "vue";
import Layout from '@/Shared/Layout'
import PageHeader from '@/Shared/PageHeader'
import Modal from "@/Shared/Modal.vue"
import VCardElement from 'vue-card-element'
import {GoogleMap, Marker} from 'vue3-google-map'
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  components: {
    Head,
    PageHeader,
    Modal,
    VCardElement, 
    GoogleMap,
    Marker,
    VueGoogleAutocomplete,
  },
  layout: Layout,
  props: {
    issues: Number,
    submitted: Number,
    drafts: Number,
    investigation: Number,
    completed: Number,
    individuals: Number,
    uploads: {
      type: Number,
      required: true,
    },
    owner: {
      type: Boolean,
      required: true
    },
  },
  setup() {
    const modalDisclaimer = ref(false);
    
    const toggleDisclaimer = () => {
      modalDisclaimer.value = !modalDisclaimer.value;
    };

    return { modalDisclaimer, toggleDisclaimer };
  },   
  mounted(){
    //Pop up Disclaimer
    //this.toggleDisclaimer()
  },
  methods:{
    closeDisclaimer(){
      this.toggleDisclaimer()
    },     
  }, 
}
</script>
